import Component from '../../common/Component';
import SlideShow from '../../common/components/SlideShow';
import ItemList from '../../common/utils/ItemList';
import app from '../app';

/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class SideBanner extends Component {

  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = false;
  }

  view() {
    return <div class='sideBanner-content'>
      <div class='web'>
        {this.getLeftBanner()}
        {this.getRightBanner()}
      </div>
      {this.showRightSmallPop()}
    </div>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();

    return items;
  }

  showRightSmallPop() {

    if (this.hidden) return null;
    return <div class='right-smallPop'>

      <img src="/assets/image/small-pop.png" onclick={this.closeSmallPop.bind(this)} />
      {/* <i class="fa close" onclick={this.closeSmallPop.bind(this)}>&#x2715;</i> */}
    </div>
  }

  closeSmallPop() {
    this.hidden = true;
  }

  getLeftBanner() {
    let data = app.adsbannerData;
    if (data) {
      let list = data.list.banner['forum_left_ad'];
      if (list) {
        return (<div class='left-banner'><SlideShow slideWidth={200} slideName="left-banner-slide" containerId="left-banner-slide" imgList={list}>
        </SlideShow></div>);
      }
    }
    return null;
  }
  getRightBanner() {
    let data = app.adsbannerData;
    if (data) {
      let list = data.list.banner['forum_right_ad'];
      if (list) {
        return (<div class='right-banner'><SlideShow slideWidth={200} slideName="right-banner-slide" containerId="right-banner-slide" imgList={list}>
        </SlideShow></div>);
      }
    }
    return null;
  }
}
